import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import {
  EnvironmentService,
  ScaffoldType,
  ScaffoldTypes,
} from '@services/environment.service';
import { UserService } from '@services/user.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-scaffold-type',
    templateUrl: './scaffold-type.component.html',
    styleUrls: ['./scaffold-type.component.scss'],
    standalone: false
})
export class ScaffoldTypeComponent implements OnInit {
  types = ScaffoldTypes;
  available: ScaffoldType[];
  private _selectedValue: ScaffoldType;
  @Output() optionsAvailable: EventEmitter<boolean> =
    new EventEmitter<boolean>();
  @Input() label: string = '';
  @Input()
  get selectedValue(): ScaffoldType {
    return this._selectedValue;
  }

  set selectedValue(value: ScaffoldType) {
    console.log('change', value);
    if (value !== this._selectedValue) {
      console.log('emit', value.type);
      this.selectedChange.emit({ type: value.type, force: false });
      this.changed.emit({ type: value.type, force: false });
    }
    this._selectedValue = value;
  }

  @Output() selectedChange: EventEmitter<{ type: string; force: boolean }> =
    new EventEmitter<{ type: string; force: boolean }>();
  @Output() changed: EventEmitter<{ type: string; force: boolean }> =
    new EventEmitter<{ type: string; force: boolean }>();

  private _selected: string;
  @Input()
  get selected(): string {
    return this._selected;
  }
  set selected(value: string) {
    console.log('SELECTED:', value);
    this._selected = value;
    if (this._selectedValue?.type !== value) {
      this._selectedValue = this.types.find(type => type.type === value);
    }
  }
  constructor(
    private environmentService: EnvironmentService,
    private userService: UserService
  ) {}

  ngOnInit(): void {
    // The instance list is fixed for the session, so only the first details are
    // useful. Re-running on a later emission announces a product change the
    // user never made, and AppComponent.setInstance answers that by navigating
    // to /home. AdminViewComponent forces a refetch on every /admin/* page.
    this.environmentService
      .getInstanceDetails()
      .pipe(take(1))
      .subscribe(details => {
        let waitForLogin;
        waitForLogin = this.userService.getLogInState().subscribe(loggedIn => {
          if (loggedIn) {
            if (waitForLogin) {
              waitForLogin.unsubscribe();
            }
            //don't bother with istance select list details if there is only one instance
            if (details?.instances?.length > 1) {
              this.userService
                .getUserInstances(details.instances)
                .subscribe(userInstances => {
                  this.available = this.types.filter(type => {
                    //get instcanes the user has acces to
                    let userDomains = details.instances.filter(inst =>
                      userInstances.includes(inst.sub_domain)
                    );
                    //get the types of the instances the user has access to
                    let userTypes = userDomains.map(inst => inst.scaffold_type);
                    //return the types that the user has access to
                    return userTypes.includes(type.type);
                  });
                  if (this.available.length === 1) {
                    const onlyType = this.available[0];
                    // Assign past the setter, which emits on its own: the
                    // explicit emits below carry the intended force values, and
                    // emitting twice runs setInstance twice.
                    this._selectedValue = onlyType;
                    // Landing on the product the instance already uses is not a
                    // change, and announcing it costs the user their page.
                    if (onlyType.type === details?.scaffoldType) {
                      return;
                    }
                    this.selectedChange.emit({
                      type: onlyType.type,
                      force: true,
                    });
                    this.changed.emit({
                      type: onlyType.type,
                      force: false,
                    });
                  } else {
                    this.optionsAvailable.emit(true);
                  }
                });
            }
          }
        });
      });
    this.environmentService.watchTypeChange().subscribe(value => {
      console.log('type', value);
      if (this._selectedValue?.type !== value) {
        this._selectedValue = this.types.find(type => type.type === value);
      }
    });
  }
}
